// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"294":"7de44729","622":"bab21408","627":"622ebf2b","884":"66c086b1"}[chunkId] + ".chunk.js";
};